import { Team } from 'dashboard/models/team';
import { TeamActions, TeamActionType } from 'dashboard/redux/actions/team';

export interface TeamState {
  team: Team | undefined;
  teamUserIds: string[];
}

export const initialState: TeamState = {
  team: undefined,
  teamUserIds: [],
};

export default (state: TeamState = initialState, action: TeamActions): TeamState => {
  switch (action.type) {
    case TeamActionType.SetTeam: {
      return {
        ...state,
        team: {
          ...action.payload.team,
          relationships: {
            ...action.payload.team.relationships,
            users: {
              data: action.payload.team.relationships.users.data
                ? action.payload.team.relationships.users.data
                : [],
            },
          },
        },
      };
    }

    case TeamActionType.SetTeamUsers: {
      return {
        ...state,
        teamUserIds: action.payload.userIds,
      };
    }

    default:
      return state;
  }
};
